import { AvatarV2 } from '@cimplico/components';
import { BuildingOfficeIcon, DocumentCheckIcon, SquaresPlusIcon, UserGroupIcon, UsersIcon } from '@heroicons/react/20/solid';
import { Firm } from '../../../types/firm';
import { parseTitle } from '../../../utilities/formatting';
import FirmSubscriptionTierBadge from './FirmSubscriptionTierBadge';

type FirmInformationProps = {
    firm: Firm;
};

function FirmInformation({ firm }: FirmInformationProps): JSX.Element {
    return (
        <div className="border border-gray-200 dark:border-white/[0.07] rounded-lg w-full overflow-hidden bg-white dark:bg-gray-800">
            {/* <div className="h-[200px] bg-gradient-to-l from-red-600 to-pink-600"></div> */}
            <div className="flex items-center gap-4 p-2">
                <AvatarV2 alt={parseTitle(firm.name)} color={firm.avatarHexColour} size="jumbo" ring />
                <div>
                    <div>
                        <h1 className="text-gray-800 dark:text-gray-200 font-medium text-xl pb-1">{firm.name}</h1>
                        <FirmSubscriptionTierBadge subscriptionTier={firm.subscription?.tier} />
                    </div>
                    {/* <div className="flex gap-4 items-center text-gray-500 dark:text-gray-400">
                        <div className="flex gap-1 items-center text-sm">
                            <BuildingOfficeIcon className="w-4 h-4" />
                            <p>1,400 entities</p>
                        </div>
                        <div className="flex gap-1 items-center text-sm">
                            <DocumentCheckIcon className="w-4 h-4" />
                            <p>59 open workpapers</p>
                        </div>
                        <div className="flex gap-1 items-center text-sm">
                            <UsersIcon className="w-4 h-4" />
                            <p>49 users</p>
                        </div>
                        <div className="flex gap-1 items-center text-sm">
                            <UserGroupIcon className="w-4 h-4" />
                            <p>6 teams</p>
                        </div>
                        <div className="flex gap-1 items-center text-sm">
                            <SquaresPlusIcon className="w-4 h-4" />
                            <p>2 integrations</p>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default FirmInformation;
